import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * 404 error page
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    standalone: true,
    imports: [TranslateModule],
})
export class NotFoundComponent {}
